<template>
  <v-card-text>
    <v-card>
      <v-toolbar dense flat color="tertiary">
        <v-toolbar-title class="custon-toolbar-title">Listagem de Veículos</v-toolbar-title>
        <v-spacer />
        <v-btn small depressed rounded color="teal" dark @click="toggleForm">
          <v-icon>mdi-plus</v-icon> Adicionar
        </v-btn>
      </v-toolbar>
      <v-card-text class="py-0">
        <v-data-table
          :headers="headers"
          :items="list"
          :item-key="list.id"
          :loading="loading"
          :options.sync="options"
          :server-items-length="paginate.total"
        >
          <template v-slot:item.acoes="{ item }">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn
                  @click="edit(item)"
                  fab
                  v-on="on"
                  depressed
                  x-small
                  color="indigo lighten-4"
                  class="mr-2"
                >
                  <v-icon small color="indigo">mdi-pencil</v-icon>
                </v-btn>
              </template>
              <span>Editar</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn
                  @click="destroyConfirm(item)"
                  fab
                  v-on="on"
                  depressed
                  dark
                  x-small
                  color="red lighten-4"
                  class="mr-2"
                >
                  <v-icon color="red" small>mdi-delete</v-icon>
                </v-btn>
              </template>
              <span>Excluir</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
    <veiculo-contrato-modal-form />
  </v-card-text>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import toastMessage, { confirmDestroyAlert } from '@/services/util/alertService';
import VeiculoContratoModalForm from '@/views/private/frota/contrato/veiculo/ModalForm.vue';

export default {
  name: 'VeiculoContratoTable',
  components: { VeiculoContratoModalForm },
  data: () => ({
    headers: [
      {
        text: 'Modelo',
        value: 'veiculo.modelo.nome',
      },
      {
        text: 'Km Inicial',
        value: 'km_inicial',
      },
      {
        text: 'Situacao',
        value: 'situacao.nome',
      },
      {
        text: 'Orgão',
        value: 'orgao_origem.nome',
      },
      {
        text: 'Valor',
        value: 'valor',
        width: '15%',
        align: 'center',
      },
      {
        text: 'Ações',
        value: 'acoes',
        width: '15%',
        align: 'center',
        sortable: false,
      },
    ],
    options: {
      itemsPerPage: 15,
    },
    search: null,
    timeoutSearch: null,
  }),
  created() {
    this.getAll(this.$route.params.id);
  },
  destroyed() {
    this.reset();
  },
  methods: {
    ...mapActions('contratoVeiculo', ['edit', 'getAll', 'destroy', 'reset', 'toggleForm']),
    destroyConfirm(item) {
      confirmDestroyAlert(item.nome).then((result) => {
        if (result.value) {
          this.destroy(item)
            .then(() => toastMessage.successDestroy('Itinerário excluído com sucesso'))
            .catch(() => toastMessage.errorDestroy('Erro ao excluír itinerário'));
        }
      });
    },
  },
  computed: {
    ...mapState('contratoVeiculo', ['loading', 'list', 'paginate']),
  },
};
</script>
